import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {FilterAbstractModel} from 'src/models/FilterAbstractModel';

@Component({
  selector: 'app-delta-flat-filter',
  templateUrl: './delta-flat-filter.component.html',
  styleUrls: ['./delta-flat-filter.component.scss']
})
export class DeltaFlatFilterComponent extends FilterAbstractModel implements OnInit, OnChanges {

  @Input() deltaFilterSelected: number;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.deltaFilterSelected)
      this.optionSelected = this.deltaFilterSelected;
  }

  ngOnChanges() {
    if (this.deltaFilterSelected) {
      this.optionSelected = this.deltaFilterSelected;
    }
  }

  reset() {
    this.optionSelected = null;
  }

}
